import { apiGetMany, apiPatch, apiPost, apiUrl } from "./ApiService";

export const patchDocument = async (subscriptionId, documentId, data) =>
  apiPatch(
    `${apiUrl}/subscriptions/${subscriptionId}/documents/${documentId}`,
    data
  );

export const bundleRefTaken = async (subscriptionId, bundleRef) => {
  const { total } = await apiGetMany(
    `${apiUrl}/subscriptions?bundleRef=${bundleRef}&status=ne:ERROR&status=ne:DELETED&_id=ne:${subscriptionId}`
  );
  return total > 0;
};

export const uploadMandateRiaDoc = async (subscriptionId, formData) =>
  apiPost(`${apiUrl}/subscriptions/${subscriptionId}/mandate-ria`, formData);
